/**
 * @created : 2021/3/26
 * @author  : 王冲
 * @desc    : h5、app应用管理
 */

import { request } from "@weapp/utils";
import { inPCClient } from "../utils";

//应用列表
export const getMobileAppModules = (params: any) => {
  params.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/app/baseserver/queryApplicationList`,
    method: "get",
    params,
  });
};
//保存排序
export const saveMobileAppModules = (data: any) => {
  data = { ...(data || {}), displayClient: inPCClient() ? "pc-weapp" : "pc" }
  return request({
    url: `/api/app/basicserver/menu/saveAppModulesAndGroups`,
    method: "post",
    data,
  });
};
//保存pc应用导航显示状态
export const savePcDisplayModules = (data: any[]) => {
  return request({
    url: `/api/basicserver/batchUpdateEmpCustMenuStatus`,
    method: "post",
    data: {
      "displayClient": "pc",
      "appMenus": data
    },
  });
};
//重置恢复团队默认设置
export const resetEmpMobileModules = () => {
  const displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/app/basicserver/menu/resetEmpNavsetting?displayClient=${displayClient}`,
    method: "post",
  });
};
